import { createSelector } from 'reselect'
import { memoize } from 'lodash'

export const selectConnectionOptionsWithEmptyState = createSelector(
  state => state.connections.filterConnections,
  connections => [
    {
      value: null,
      label: 'All',
    },
    ...connections,
  ]
)

export const selectConnectionOptions = createSelector(
  state => state.connections.filterConnections,
  connections => connections
)

export const selectTimeActivitiesConnectionOptions = createSelector(
  state => state.connections.filterConnections,
  connections => {
    const filtered = connections.filter(connection => connection.enableTimeActivities)
    const connectionsByUuid = new Map()

    filtered.forEach(connection => {
      const clientUuid = connection.uuid
      if (!connectionsByUuid.has(clientUuid)) {
        connectionsByUuid.set(clientUuid, [])
      }
      connectionsByUuid.get(clientUuid).push(connection)
    })

    const result = []
    connectionsByUuid.forEach((connList, clientUuid) => {
      const directConnection = connList.find(conn => !conn.isShared)
      const selectedConnection = directConnection || connList[0]

      const hasDirectConnection = connList.some(conn => !conn.isShared)

      result.push({
        ...selectedConnection,
        isShared: selectedConnection.isShared && !hasDirectConnection,
      })
    })

    return result
  }
)

export const selectExpenseActivitiesConnectionOptions = createSelector(
  state => state.connections.filterConnections,
  connections => {
    const filtered = connections.filter(connection => connection.enableExpenseActivities)
    // Remove duplicates: if multiple connections have same client UUID, keep only one
    // Prefer direct connections over shared ones
    const connectionsByUuid = new Map()

    // First pass: collect all connections by UUID
    filtered.forEach(connection => {
      const clientUuid = connection.uuid
      if (!connectionsByUuid.has(clientUuid)) {
        connectionsByUuid.set(clientUuid, [])
      }
      connectionsByUuid.get(clientUuid).push(connection)
    })

    // Second pass: select one connection per UUID (prefer direct over shared)
    const result = []
    connectionsByUuid.forEach((connList, clientUuid) => {
      // Find direct connection (not shared)
      const directConnection = connList.find(conn => !conn.isShared)
      // If direct connection exists, use it; otherwise use the first one (which would be shared)
      const selectedConnection = directConnection || connList[0]

      // Check if there's a direct connection with same UUID
      const hasDirectConnection = connList.some(conn => !conn.isShared)

      // Set isShared only if connection is shared AND there's no direct connection
      result.push({
        ...selectedConnection,
        isShared: selectedConnection.isShared && !hasDirectConnection,
      })
    })

    return result
  }
)
